<template lang="pug">
v-select(
  v-bind='$attrs'
  v-bind.props='$props'
  @input='$emit("input", $event)'
  @change='$emit("change", $event)'
  :items='list'
  item-value='id'
  item-text='name'
)
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import picker from '@/mixins/picker'

export default {
  mixins: [picker],

  props: {
    label: {
      default: 'Выберите тип метки'
    }
  },

  created() {
    this.fetch()
  },

  methods: mapActions('dictionary/markTypes', ['fetch']),

  computed: {
    list() {
      return this.filterList(this.filter)
    },

    ...mapGetters('dictionary/markTypes', ['filterList'])
  }
}
</script>
